module.exports = __webpack_public_path__ + "static/media/logo5.dbcecab5.png";